import type {ReactElement} from 'react';
import React from 'react';

export interface PanelFooterPrimaryCustomActionProps {
  children?: ReactElement<any>;
  className?: string;
}

export function PanelFooterPrimaryCustomAction({className = '', children = <div />}: PanelFooterPrimaryCustomActionProps) {
  return (
    <>
      {className
        ? React.cloneElement(children, {
            className: `${children.props.className} ${className}`,
          })
        : children}
    </>
  );
}
